const RadioYesNo = ({ label, value, onChange }) => {
  const handleClick = (selectedValue) => {
    if (value === selectedValue) {
      onChange(undefined); // clears selection
    } else {
      onChange(selectedValue);
    }
  };

  return (
    <div className="provider-network-radio-group">
      <div className="FP_Body black">{label}</div>

      <label className="FP_Content">
        <input
          type="radio"
          checked={value === true}
          onClick={() => handleClick(true)}
          onChange={() => {}}
        />
        Yes
      </label>

      <label className="FP_Content">
        <input
          type="radio"
          checked={value === false}
          onClick={() => handleClick(false)}
          onChange={() => {}}
        />
        No
      </label>
    </div>
  );
};

export default RadioYesNo;
